export function polylineD(points: readonly number[], closed = false): string {
  if (points.length < 4) return ''
  let d = `M ${points[0]} ${points[1]}`
  for (let i = 2; i + 1 < points.length; i += 2) d += ` L ${points[i]} ${points[i + 1]}`
  return closed ? `${d} Z` : d
}

/**
 * Freehand path smoothed with quadratics through segment midpoints. Cheap, and
 * it removes the polygonal look a raw polyline has at low point counts.
 */
export function smoothStrokeD(points: readonly number[]): string {
  const n = points.length / 2
  if (n === 0) return ''
  const px = (i: number) => points[i * 2]!
  const py = (i: number) => points[i * 2 + 1]!

  // A single point still needs to paint a dot, which needs a zero-length line.
  if (n === 1) return `M ${px(0)} ${py(0)} L ${px(0)} ${py(0)}`
  if (n === 2) return `M ${px(0)} ${py(0)} L ${px(1)} ${py(1)}`

  let d = `M ${px(0)} ${py(0)}`
  for (let i = 1; i < n - 1; i++) {
    const mx = (px(i) + px(i + 1)) / 2
    const my = (py(i) + py(i + 1)) / 2
    d += ` Q ${px(i)} ${py(i)} ${mx} ${my}`
  }
  d += ` L ${px(n - 1)} ${py(n - 1)}`
  return d
}
